import { Button, Box, Icon } from "@chakra-ui/react";
import { ReactElement } from "react";
import { IoMic, IoStop } from "react-icons/io5";
import { RecordingState } from "../../types";
import { useModifiedTranslation } from "../../hooks/useModifiedTranslation";

export function RecordingButton(
  props: Readonly<{
    recordingState: RecordingState;
    isRerecord?: boolean;
    onClick: () => void;
  }>,
): ReactElement {
  const t = useModifiedTranslation();
  const height = "80px";

  switch (props.recordingState) {
    case "INITIALIZING":
    case "PREPARING":
    case "IDLE":
      return (
        <Button
          data-testid="recording-button"
          variant="btn_primary"
          width="80%"
          height={height}
          margin="auto auto 0"
          isLoading={props.recordingState !== "IDLE"}
          onClick={props.onClick}
          leftIcon={<Icon as={IoMic} boxSize={8} />}
          iconSpacing={8}
          fontSize="xl"
        >
          {!props.isRerecord
            ? t("Recording.startRecording")
            : t("Recording.startRerecording")}
        </Button>
      );
    case "STOPPING":
    case "RECORDING":
      return (
        <Button
          data-testid="recording-button"
          variant="btn_primary"
          width="80%"
          height={height}
          margin="auto auto 0"
          isLoading={props.recordingState === "STOPPING"}
          onClick={props.onClick}
          leftIcon={<Icon as={IoStop} boxSize={8} />}
          iconSpacing={8}
          fontSize="xl"
        >
          {!props.isRerecord
            ? t("Recording.stopRecording")
            : t("Recording.stopRerecording")}
        </Button>
      );
    case "COMPLETED":
      return <Box height={height} />;
  }
}
